<template>
  <div class="date-picker d-flex align-center">
    <v-menu
      v-model="isShow"
      transition="scale-transition"
      :close-on-content-click="false"
      offset-y min-width="0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="date"
          v-bind="attrs" v-on="on"
          append-icon="calendar_today"
          outlined dense readonly hide-details
          class="dateAlign" background-color="white"
          @click:append="isShow = !isShow"
          :disabled="disabled"
        />
      </template>
      <v-date-picker
        v-model="date" locale="ko-kr"
        @input="closeClick"
        :show-current="false"
        :day-format="removeBackWord"
        :disabled="disabled"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["startDate", "disabled"],
  data() {
    return {
      isShow: false,
      date: ""
    }
  },
  created() {
    this.date = this.startDate;
  },
  methods: {
    validation() {
      this.$emit("updateDate", this.date);
    },
    removeBackWord(d) {
      return new Date(d).getDate();
    },
    closeClick() {
      this.validation();
      this.isShow = false;
    }
  }
}
</script>

<style>
.date-picker {
  flex: 1 1 auto;
}
</style>